import executeRequest, { API_GetConfig, RequestOutput } from 'app/api'

export type API_Geti18n = { [key: string]: string }

type Geti18nRequestParams = {
  locale: string
}
type Geti18nResponse = API_Geti18n
enum Geti18nReponseError {
}
export async function geti18n(params: Geti18nRequestParams, config?: API_GetConfig, output?: RequestOutput<Geti18nResponse, Geti18nReponseError>) {
  executeRequest({
    endpoint: config?.app.i18nUrl + params.locale + '.json',
    config: config,
    params: params,
    output: output,
  })
}
